enum Stores {
    US = 'us-store',
    CA = 'ca-store',
}

const webInventoryToStore = {
    ps_ca_web_inv: 'ca-store',
    ps_us_web_inv: 'us-store',
};

export { Stores, webInventoryToStore };
